import React, { useMemo } from 'react';
import Modal from 'react-modal';
import './ConversationAnalysisModal.scss';
import { BaseWidget } from 'models/WidgetModel';
import { createFieldMap, transformRowData } from 'helpers/dataGridTransformation';
import ConversationAnalysisWorkspace from '../ConversationAnalysisWorkspace/ConversationAnalysisWorkspace';

interface ConversationAnalysisModalProps extends BaseWidget {
  modalOpen: boolean;
  onRequestClose: () => void;
  secondaryCategory?: any;
  onChangeCategory?: (cat: any) => void;
}

const modalStyle: Modal.Styles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.55)',
    zIndex: 99999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  content: {
    position: 'relative',
    inset: 'unset',
    width: '95vw',
    maxWidth: '1620px',
    height: '93vh',
    maxHeight: '93vh',
    padding: 0,
    border: 'none',
    borderRadius: '12px',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
};

const ConversationAnalysisModal: React.FC<ConversationAnalysisModalProps> = ({
  modalOpen,
  onRequestClose,
  secondaryCategory,
  onChangeCategory,
  response,
  options,
  ...props
}) => {
  // Transform secondaryCategory (field_N keys) to named keys using the outer response columns,
  // matching the same pattern as ContextualAnalysisModal
  const transformedCategory = useMemo(() => {
    if (!secondaryCategory || !response?.data?.columns) return null;
    const fieldMap = createFieldMap(response.data.columns);
    return transformRowData(secondaryCategory, fieldMap);
  }, [secondaryCategory, response?.data?.columns]);

  if (!transformedCategory) return null;

  return (
    <Modal
      isOpen={modalOpen}
      onRequestClose={onRequestClose}
      style={modalStyle}
      contentLabel="Conversation Analysis"
      ariaHideApp={false}
      bodyOpenClassName="ca-conversation-modal-open"
    >
      <ConversationAnalysisWorkspace
        secondaryCategory={transformedCategory}
        onChangeCategory={onChangeCategory ?? onRequestClose}
        onRequestClose={onRequestClose}
        response={response}
        options={options}
        {...props}
      />
    </Modal>
  );
};

export default ConversationAnalysisModal;
